<template>
  <Page
    :step="step"
    :desktop="desktop"
    :title="title"
    :message="message"
    :inputs="totalInputs"
    :finished="touchedInputs"
  >

    <div class="input-wrap">
      <label for="name">First name</label>
      <input
        aria-required="true"
        type="text"
        @keydown="incrementInput"
      >
    </div>

    <div class="input-wrap">
      <label for="last-name">Last name</label>
      <input
        aria-required="true"
        type="text"
        @keydown="incrementInput"
      >
    </div>

    <div class="input-wrap">
      <label for="email">Email address</label>
      <input
        type="email"
        id="email"
        required
        @keydown="incrementInput"
      >
    </div>

    <div class="input-wrap checkbox-wrap">
      <div>
        <input
          type="checkbox"
          class="checkbox"
          name="checkboxes"
          value="check_1"
        >
      </div>
      <label for="checkbox">
        Email me updates from toucanBox (we'll never share your details with anyone else)
      </label>
    </div>

    <button
      class="success cta continue-button"
      @click="next">Continue<i class="fa fa-play"/></button>

  <!-- <p>Your box will be shipped next working day. It should be with you in 3-4 working days.</p> -->
  <!-- <a @click="toggleLogin">Already have an account?</a>
    <transition name="fade">
      <Login
        v-if="loginActive"
        @dismiss="toggleLogin"
      />
    </transition> -->
  </Page>
</template>

<script>
import Page from '../library/page.vue'
import Login from '../library/login.vue'

export default {
  name: 'Account',
  props: {
    step: {
      type: Number,
      default: 0
    },
    desktop: {
      type: Boolean,
      default: true
    }
  },
  components: {
    Page,
    Login
  },
  data () {
    return {
      title: 'Your details',
      message: 'Create an account to easily manage your subscription.',
      loginActive: false,
      totalInputs: 3,
      touchedInputs: 0,
      inputTimer: null
    }
  },
  methods: {
    next: function (event) {
      this.$emit('next')
      this.$emit('update-signup-object')
    },
    incrementInput: function (event) {
      clearTimeout(this.inputTimer)
      this.inputTimer = setTimeout(() => {
        if (this.touchedInputs < this.totalInputs && !event.target.parentNode.classList.contains('valid')) {
          this.touchedInputs++
        }
        event.target.parentNode.classList.add('valid')
      }, 300)
    },
    toggleLogin: function (event) {
      this.loginActive = !this.loginActive
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/account.vue